export default "__VITE_ASSET__zGB1Xkal__"